import { Check } from "@phosphor-icons/react";
import { fileUrl } from "../lib/api";

export function VerifiedBadge({ user, className = "h-4 w-4" }) {
  if (!user?.verified) return null;
  return (
    <span title="Verified caregiver" aria-label="Verified caregiver" data-testid="verified-badge"
      className={`${className} shrink-0 inline-flex items-center justify-center rounded-full bg-primary/15 text-primary align-middle`}>
      <Check weight="bold" className="h-[62%] w-[62%]" />
    </span>
  );
}

const TONES = ["#34C759", "#30B0C7", "#5E5CE6", "#FF9F0A", "#AF52DE", "#64A36F"];

const initials = (name = "") =>
  name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "?";

const tone = (id = "") => TONES[[...id].reduce((a, c) => a + c.charCodeAt(0), 0) % TONES.length];

export function UserAvatar({ user, className = "h-8 w-8 text-xs", testid }) {
  if (!user) return null;
  return user.avatar_path ? (
    <img data-testid={testid} loading="lazy" decoding="async" src={fileUrl(user.avatar_path, 160)} alt={user.name} className={`${className} rounded-full object-cover shrink-0`} />
  ) : (
    <span
      data-testid={testid}
      className={`${className} rounded-full shrink-0 inline-flex items-center justify-center font-semibold text-white`}
      style={{ background: tone(user.id) }}
    >
      {initials(user.name)}
    </span>
  );
}
